function trackEvent(event: string, properties: {}) {
  // nothing for now, we removed mixpanel
}

export default {
  trackEvent
};
